import React from 'react';

import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { useIntl } from 'react-intl';

import type {
	CommonDraggableSideNavItemProps,
	DefaultItemType,
} from '@townsquare/griffin-navigation/types';

// Side nav item with external link icon
export const ExternalSideNavItem = ({
	draggableRef,
	dropIndicator,
	hasDragIndicator,
	item,
	isDragging,
	isSelected,
	onClick,
	visualContentRef,
}: CommonDraggableSideNavItemProps & { item: DefaultItemType }): React.JSX.Element => {
	const intl = useIntl();

	const linkLabel = intl.formatMessage({
		id: 'townsquare.atlassian-home.side-nav.open-in-new-tab',
		description:
			'Label on an external link icon for links to products in the side nav which will open the link in a new tab',
		defaultMessage: 'Open in new tab',
	});

	return (
		<LinkMenuItem
			onClick={(e) => onClick(item, e)}
			isSelected={isSelected}
			href={item.path}
			elemBefore={<item.Icon label="" />}
			elemAfter={
				<LinkExternalIcon label={linkLabel} color="currentColor" spacing="spacious" size="small" />
			}
			testId={item.testId}
			hasDragIndicator={hasDragIndicator}
			ref={draggableRef}
			isDragging={isDragging}
			dropIndicator={dropIndicator}
			visualContentRef={visualContentRef}
		>
			{item.name}
		</LinkMenuItem>
	);
};
